module.exports = __webpack_public_path__ + "static/media/C5.225d72a6.mp3";